
import { Component, Vue, Prop } from 'vue-property-decorator';
import Steps from "@/modules/steps";


@Component({
    components: {
    }
})
export default class StepFormItem extends Vue {
    @Prop()
    public value!: string;

    public onValueChange(newVal: number|null) {
        newVal = newVal || null;
        this.$emit('input', newVal);
    }

    public Steps = Steps;
}

